module.exports = __webpack_public_path__ + "img/info2.7235c967.jpg";